import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hui from 'hui';
import api from 'axios';
import { memoize } from 'lodash';

const PostcodeAutocomplete = hui.PostcodeAutocomplete;

export default class PostcodeSearch extends Component {
  static propTypes = { // eslint-disable-line
    classPrefix: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onSelect: PropTypes.func
  };

  static defaultProps = { // eslint-disable-line 
    classPrefix: 'hero__directory-postcode',
    name: 'w',
    placeholder: 'Enter postcode'
  };

  state = {
    postcodeValue: ''
  };

  onChange = (postcodeValue) => {
    if (this.props.onSelect) this.props.onSelect(postcodeValue);
    this.setState({ postcodeValue });
  };

  render() {
    const { onFocus, onBlur } = this.props;
    const { postcodeValue } = this.state;
    return (
      <PostcodeAutocomplete
        classPrefix={this.props.classPrefix}
        value={postcodeValue}
        data-placeholder={this.props.placeholder}
        placeholder={this.props.placeholder}
        onChange={this.onChange}
        name={this.props.name}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/components/postcode-autocomplete.js